export const customSearcher = (itemsMetadata, itemKey = 'Id', filter = []) =>
  (items, index) => {
    if (index == '' || index == null) {
      filter.items = items
      return items
    }

    let resultObject = {}
    let normalizedIndex = index.toLowerCase()
    let terms = normalizedIndex.split('@@@@')
    terms = terms.map(term => term.split(' '))
    terms.forEach(term => {
      if (!(term.length == 1 && term[0] == '')) {
        for (let i = 0; i < items.length; i++) {
          let item = items[i]

          if (resultObject[item[itemKey]]) continue
          let values = itemsMetadata[item[itemKey]]

          let failed = false
          for (const subterm of term) {
            if (!matchesString(values, subterm)) {
              failed = true
              break
            }
          }
          if (failed) continue

          resultObject[item[itemKey]] = i
        }
      }
    })

    let entries = Object.entries(resultObject)
    let result = []
    for (const [ /*key*/ , value] of entries) {
      result.push(items[value])
    }

    filter.items = result

    return result
  }

// only meant for one nesting
export function getObjectValues(object, ...keys) {
  if (object instanceof Array) {
    return object.map(value => getObjectValues(value))
  } else if (object instanceof Object) {
    if (!keys) return []
    let result = keys.map(key => {
      if (key instanceof Object && key.format) {
        return getObjectValues(key.format(object[key.name]))
      } else if (key instanceof Object) {
        return getObjectValues(object[key.name])
      } else {
        return getObjectValues(object[key])
      }
    })

    return result.flatten()
  } else {
    return typeof object == 'string' ? object.toLowerCase() : object
  }
}

export function matchesString(values, string) {
  if (!values) {
    console.error('Values should be empty [] not null')
    return false
  }

  if (!string || string.length == 0) {
    return true
  }

  for (let i = 0; i < values.length; i++) {
    if (
      (typeof values[i] == 'string' && (values[i].indexOf(string) != -1)) ||
      (values[i] == string)
    ) return true
  }

  return false
}